export default {"src":"/_next/static/media/human-emotions.colour.d7ddc4c7.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};